<div class="copy-text-hud" id="copy-text-success">
    <div>
        <img [src]="imgSrc" alt="Icon">
        <span>Text in die Zwischenablage kopiert</span>
    </div>
</div>
<div class="copy-text-hud copy-text-hud-error" id="copy-text-error">
    <div>
        <img [src]="imgSrc" alt="Icon">
        <span>Text konnte nicht kopiert werden</span>
    </div>
</div>
